import React, {Component} from "react";
import {Row, Col, Collapse} from 'reactstrap';
import '../Review.css';

export default class ReviewUploadDataMappedColumns extends Component {

    constructor(props) {
       super(props);
       this.state = {
           isMappedColumnsOpened: false
       }
    }

    render() {
        let { uploadDataMappedColumns, uploadDataAllColumns } = this.props;
        let {isMappedColumnsOpened} = this.state;
        //uploadDataMappedColumns = uploadDataMappedColumns.filter(uploadDataMappedColumn => uploadDataMappedColumn.value.label!=='' && uploadDataMappedColumn.value.value!=='');
        return (
        <div className="review-sub-section">
            <Row>
                <Col sm="11" md="11" className="review-sub-section-heading">Importing {uploadDataMappedColumns.length} of {uploadDataAllColumns.length} columns</Col>
                <Col sm="1" md="1" className={isMappedColumnsOpened ? 'rotate-arrow' : 'text-center'}>
                    <i className={(isMappedColumnsOpened ? 'flaticon-down-arrow ' : 'flaticon-down-arrow').concat(' review-flaticon-down-arrow cursor-pointer')}
                        onClick={() => {
                            this.setState({ isMappedColumnsOpened: !isMappedColumnsOpened });
                        }} />
                </Col>
            </Row>
            <Collapse isOpen={isMappedColumnsOpened}>
                 <div className="mt30 mapped-review-records">
                   {uploadDataMappedColumns.map((uploadDataMappedColumn, index) => {
                       let values = uploadDataMappedColumn.value.length!==undefined? uploadDataMappedColumn.value.map((e, index)=>e.label + (index+1==uploadDataMappedColumn.value.length?'':' and ')):uploadDataMappedColumn.value.label
                        return (<div key={index} className={'review-mapped-column '.concat(index === 0 ? ' ' : 'mt10')}>
                            <span style={{ fontWeight: '600' }}>
                                {uploadDataMappedColumn.csvField}
                            </span>
                             {uploadDataMappedColumn.value.label!=="" ? <span><span> mapped to </span>
                            <span style={{ fontWeight: '600' }}>{values}</span>
                            </span>: <span> left unmapped</span>
                            
                            }
                        </div>
                        )
                    })}
                </div> 
            </Collapse>
        </div>
                )
    }
}
